import { env } from '../env';

export const DISPLAY_STEP = 5;

export const STATE_PENDING = 1;
export const STATE_VALID = 2;
export const STATE_INVALID = 4;

// estimated number of days to validate a payment request
export const PAYMENT_DELAY = 21;

export const PAYMENT_REQUEST_TYPE_EBON_ORDER = Number(env.REACT_APP_PAYMENT_REQUEST_EBON_TYPE);



// WEBPACK FOOTER //
// ./src/constants/payment.js